import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useTranslation } from "react-i18next";

const BillingHistory = ( props ) => {

    const [translation] = useTranslation("translations");

    return (
        <div className="row">

            <div className="col-12 mt-3 mb-4">
                <h3>{translation("billing_history")}</h3>
            </div>

            { ! props?.stripeData?.invoices &&
                <div className="my-3 w-100">
                    <div className="alert alert-secondary" role="alert">
                        <span>{translation("no_invoices")}</span>
                    </div>
                </div>
            }

            { props?.stripeData?.invoices &&
                <div className="col-12">
                    <div className="table-responsive">
                        <table className="table align-middle table-striped">
                            <thead className="table-light">
                                <tr>
                                    <th scope="col">{translation("invoice_text")}</th>
                                    <th scope="col">{translation("amount_text")}</th>
                                    <th scope="col">{translation("date_text")}</th>
                                    <th scope="col">{translation("status_text")}</th>
                                    <th scope="col">{translation("actions_text")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                { props?.stripeData?.invoices?.map( (invoice, index) => {

                                    let paidAmount = 0;

                                    if ( invoice.amount_due && invoice.amount_due > 0 ) {
                                        paidAmount = invoice.amount_due/100;
                                    }

                                    const dataObject = new Date((invoice.date*1000));
                                    const options = { year: 'numeric', month: 'long', day: 'numeric' };
                                    const invoiceDate = dataObject.toLocaleDateString('sv-SE', options);

                                    let statusColor = 'sy-green';

                                    if ( invoice.status === 'uncollectible' || invoice.status === 'void' ) {
                                        statusColor = 'sy-red';
                                    } else if ( invoice.status === 'draft' || invoice.status === 'open' ) {
                                        statusColor = 'sy-gray';
                                    }


                                    return(
                                        <tr key={index}>
                                            <td className="font-size-medium">{invoice.lines?.data[0]?.description}</td>
                                            <td className="font-size-medium">{paidAmount} <span className="text-uppercase">{invoice.lines?.data[0]?.currency}</span></td>
                                            <td className="font-size-medium"><span className="text-capitalize">{invoiceDate}</span></td>
                                            <td className="font-size-medium text-center"><span className={`text-capitalize badge rounded-pill bg-${statusColor}`}>{invoice.status}</span></td>
                                            <td>
                                                <span className="me-1">
                                                    <OverlayTrigger
                                                        placement="bottom"
                                                        overlay={
                                                            <Tooltip id={`tooltip-trash-btn-${index}`}>{translation("view_text")}</Tooltip>
                                                        }
                                                        >
                                                        <a href={invoice.hosted_invoice_url} target="_blank" className="btn btn-link py-0 px-1 text-white bg-secondary rounded-0" rel="noopener noreferrer">
                                                            <i className="fa fa-eye" aria-hidden="true"></i>
                                                        </a>
                                                    </OverlayTrigger>
                                                </span>
                                                <span >
                                                    <OverlayTrigger
                                                        placement="bottom"
                                                        overlay={
                                                            <Tooltip id={`tooltip-trash-btn-${index}`}>{translation("download_text")}</Tooltip>
                                                        }
                                                        >
                                                        <a href={invoice.invoice_pdf} target="_blank" className="btn btn-link py-0 px-1 text-white bg-secondary rounded-0" rel="noopener noreferrer">
                                                            <i className="fa fa-cloud-download" aria-hidden="true"></i>
                                                        </a>
                                                    </OverlayTrigger>
                                                </span>
                                            </td>
                                        </tr>
                                    )

                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            }
        </div>
    )
}

export default BillingHistory;